<template>
  <div
    v-if="isVisible"
    class="modal fade show"
    id="issuesPop"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="false"
    style="display: block; background-color: rgba(0,0,0,0.5);"
    @click.self="closePopup"
  >
    <div class="modal-dialog issuespop" role="document">
      <div class="modal-content">
        <div class="pop-issues-top">
          <h1>
            {{ constants.CREATED_RESLOVED_ISSUES_TEXT }} - {{ popupData.month }} {{ new Date().getFullYear() }}
          </h1>
          <p style="margin: 5px 0; color: #666; font-size: 14px;">
            Project: {{ popupData.projectKey }}
          </p>
          <button
            type="button"
            id="issuesPopCloseBtn"
            class="close"
            @click="closePopup"
            aria-label="Close"
          >
            <img src="@/assets/lems-v1/images/close-black-icon.svg" alt="" />
          </button>
        </div>
        <div class="pop-issues-content">
          <div class="nav" nav-ta id="b" role="tablist">
            <button
              class="active"
              id="nav-home-tab"
              data-bs-toggle="tab"
              href="#nav-home"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
            >
              {{ constants.CREATED_ISSUES_BUTTON }}
            </button>
            <button
              class=""
              id="nav-profile-tab"
              data-bs-toggle="tab"
              href="#nav-profile"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false"
            >
              {{ constants.RESOLVED_ISSUES_BUTTON }}
            </button>
          </div>

          <div class="tab-content pop-issues-mid" id="nav-tabContent">
            <div
              class="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div class="right-open-issues-row">
                <div v-if="createdIssues.length === 0" class="no-data">
                  <p>No created issues found for {{ popupData.month }} {{ new Date().getFullYear() }} in project {{ popupData.projectKey }}</p>
                      </div>
                <ul v-else>
                  <li v-for="issue in paginatedCreatedIssues" :key="issue.id">
                    <router-link :to="`/employee/issue-detail/${issue.key}`">
                      <i>
                        <img :src="issue.fields.issuetype.iconUrl" alt="" />
                      </i>
                      <div class="open-issues-content">
                        <strong>{{ issue.key }}</strong>
                        <p>{{ issue.fields.summary }}</p>
                      </div>
                    </router-link>
                  </li>
                </ul>
                <!-- Pagination for created issues -->
                <div class="pagination-box" v-if="createdTotalPages > 1">
                  <ul>
                    <li
                      class="pagination-first"
                      v-if="createdCurrentPage !== 1"
                      @click="changeCreatedPage(createdCurrentPage - 1)"
                    >
                      <button id="paginationPreButton"></button>
                    </li>
                    <li
                      v-for="page in createdVisiblePages"
                      :key="page"
                      @click="changeCreatedPage(page)"
                    >
                      <a href="#" :class="{ active: createdCurrentPage === page }">{{ page }}</a>
                    </li>
                    <li
                      class="pagination-last"
                      v-if="createdCurrentPage !== createdTotalPages"
                      @click="changeCreatedPage(createdCurrentPage + 1)"
                    >
                      <button id="paginationNextButton"></button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="nav-profile"
              role="tabpanel"
              aria-labelledby="nav-profile-tab"
            >
              <div class="right-open-issues-row">
                <div v-if="resolvedIssues.length === 0" class="no-data">
                  <p>No resolved issues found for {{ popupData.month }} {{ new Date().getFullYear() }} in project {{ popupData.projectKey }}</p>
                      </div>
                <ul v-else>
                  <li v-for="issue in paginatedResolvedIssues" :key="issue.id">
                    <router-link :to="`/employee/issue-detail/${issue.key}`">
                      <i>
                        <img :src="issue.fields.issuetype.iconUrl" alt="" />
                      </i>
                      <div class="open-issues-content">
                        <strong>{{ issue.key }}</strong>
                        <p>{{ issue.fields.summary }}</p>
                      </div>
                    </router-link>
                  </li>
                </ul>
                <!-- Pagination for resolved issues -->
                <div class="pagination-box" v-if="resolvedTotalPages > 1">
                  <ul>
                    <li
                      class="pagination-first"
                      v-if="resolvedCurrentPage !== 1"
                      @click="changeResolvedPage(resolvedCurrentPage - 1)"
                    >
                  <button id="paginationPreButton"></button>
                </li>
                    <li
                      v-for="page in resolvedVisiblePages"
                      :key="page"
                      @click="changeResolvedPage(page)"
                    >
                      <a href="#" :class="{ active: resolvedCurrentPage === page }">{{ page }}</a>
                </li>
                    <li
                      class="pagination-last"
                      v-if="resolvedCurrentPage !== resolvedTotalPages"
                      @click="changeResolvedPage(resolvedCurrentPage + 1)"
                    >
                  <button id="paginationNextButton"></button>
                </li>
              </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";
import axios from "axios";
import { API_BASE_URL } from "@/config/api.config";

interface PopupData {
  month: string;
  projectKey: string;
  created: number;
  resolved: number;
}

interface Issue {
  id: string;
  key: string;
  fields: {
    summary: string;
    issuetype: {
      iconUrl: string;
    };
    status: {
      name: string;
    };
    created: string;
    resolutiondate?: string;
  };
}

export default defineComponent({
  name: "IssuePopup",
  props: {
    popupData: {
      type: Object as () => PopupData,
      required: true
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      constants,
      createdIssues: [] as Issue[],
      resolvedIssues: [] as Issue[],
      loading: false,
      activeTab: 'created',
      // Pagination for created issues
      createdCurrentPage: 1,
      createdTotalPages: 0,
      createdIssuesPerPage: 10,
      // Pagination for resolved issues
      resolvedCurrentPage: 1,
      resolvedTotalPages: 0,
      resolvedIssuesPerPage: 10
    };
  },
  computed: {
    paginatedCreatedIssues(): Issue[] {
      const start = (this.createdCurrentPage - 1) * this.createdIssuesPerPage;
      const end = start + this.createdIssuesPerPage;
      return this.createdIssues.slice(start, end);
    },
    
    paginatedResolvedIssues(): Issue[] {
      const start = (this.resolvedCurrentPage - 1) * this.resolvedIssuesPerPage;
      const end = start + this.resolvedIssuesPerPage;
      return this.resolvedIssues.slice(start, end);
    },
    
    createdVisiblePages(): number[] {
      const maxVisiblePages = 5;
      const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
      let start = Math.max(this.createdCurrentPage - halfMaxVisiblePages, 1);
      let end = start + maxVisiblePages - 1;

      if (end > this.createdTotalPages) {
        end = this.createdTotalPages;
        start = Math.max(end - maxVisiblePages + 1, 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    
    resolvedVisiblePages(): number[] {
      const maxVisiblePages = 5;
      const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
      let start = Math.max(this.resolvedCurrentPage - halfMaxVisiblePages, 1);
      let end = start + maxVisiblePages - 1;

      if (end > this.resolvedTotalPages) {
        end = this.resolvedTotalPages;
        start = Math.max(end - maxVisiblePages + 1, 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        this.fetchIssues();
        this.addBackdrop();
      } else {
        this.removeBackdrop();
      }
    },
    popupData: {
      handler() {
        if (this.isVisible) {
          this.fetchIssues();
        }
      },
      deep: true
    }
  },
  mounted() {
    // Prevent Bootstrap from interfering with our modal
    this.preventBootstrapInterference();
  },
  beforeUnmount() {
    // Clean up backdrop when component is destroyed
    this.removeBackdrop();
  },
  methods: {
    async fetchIssues() {
      if (!this.popupData.projectKey || !this.popupData.month) return;
      
      try {
        const username = localStorage.getItem("jira_user_username");
        if (!username) return;

        console.log(`Fetching issues for month: ${this.popupData.month}, project: ${this.popupData.projectKey}`);

        // Calculate date range for the specific month
        const year = new Date().getFullYear();
        const monthIndex = this.getMonthIndex(this.popupData.month);
        const startDate = new Date(year, monthIndex, 1);
        const endDate = new Date(year, monthIndex + 1, 0);
        
        const startDateStr = startDate.toISOString().split('T')[0];
        const endDateStr = endDate.toISOString().split('T')[0];

        console.log(`Date range: ${startDateStr} to ${endDateStr}`);

        // Fetch created issues for this specific month
        const createdResponse = await axios.get(
          `${API_BASE_URL}/jira/issues/${username}/?project=${this.popupData.projectKey}&created_start=${startDateStr}&created_end=${endDateStr}&user_filter=created&limit=1000`
        );
        
        console.log(`Created issues response:`, createdResponse.data);
        this.createdIssues = createdResponse.data.issues || [];
        this.createdTotalPages = Math.ceil(this.createdIssues.length / this.createdIssuesPerPage);
        this.createdCurrentPage = 1; // Reset to first page

        // Fetch resolved issues for this specific month
        const resolvedResponse = await axios.get(
          `${API_BASE_URL}/jira/issues/${username}/?project=${this.popupData.projectKey}&resolved_start=${startDateStr}&resolved_end=${endDateStr}&user_filter=created&limit=1000`
        );
        
        console.log(`Resolved issues response:`, resolvedResponse.data);
        this.resolvedIssues = resolvedResponse.data.issues || [];
        this.resolvedTotalPages = Math.ceil(this.resolvedIssues.length / this.resolvedIssuesPerPage);
        this.resolvedCurrentPage = 1; // Reset to first page

        console.log(`Found ${this.createdIssues.length} created issues and ${this.resolvedIssues.length} resolved issues for ${this.popupData.month}`);

      } catch (error) {
        console.error("Error fetching issues:", error);
        this.createdIssues = [];
        this.resolvedIssues = [];
        this.createdTotalPages = 0;
        this.resolvedTotalPages = 0;
      }
    },

    getMonthIndex(month: string): number {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return months.indexOf(month);
    },

    closePopup() {
      this.$emit('close');
    },

    preventBootstrapInterference() {
      // Remove any Bootstrap event listeners that might interfere
      const modalElement = document.getElementById('issuesPop');
      if (modalElement) {
        // Remove Bootstrap data attributes that might trigger initialization
        modalElement.removeAttribute('data-bs-toggle');
        modalElement.removeAttribute('data-bs-target');
        modalElement.removeAttribute('data-bs-dismiss');
      }
    },

    addBackdrop() {
      // Add modal backdrop to body
      const backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show';
      backdrop.id = 'issuesPopBackdrop';
      document.body.appendChild(backdrop);
      document.body.classList.add('modal-open');
    },

    removeBackdrop() {
      // Remove modal backdrop from body
      const backdrop = document.getElementById('issuesPopBackdrop');
      if (backdrop) {
        backdrop.remove();
      }
      document.body.classList.remove('modal-open');
    },

    changeCreatedPage(page: number) {
      if (page > 0 && page <= this.createdTotalPages) {
        this.createdCurrentPage = page;
      }
    },

    changeResolvedPage(page: number) {
      if (page > 0 && page <= this.resolvedTotalPages) {
        this.resolvedCurrentPage = page;
      }
    }
  }
});
</script>
